
import "/app/src/modules/zy-crm/components/markdown/style.module.less?modules";
export default {"footer": `footer-U0IgdxGP`,"editor": `editor-zbb7boY1`,"view": `view-IEk-N1DI`,"plain": `plain-SYiR3BTW`}
